import { differenceInCalendarDays, differenceInYears, parseISO } from 'date-fns'

export type DateOrNone = string | Date | null | undefined

function asDate(date: DateOrNone): Date | number {
  return date === null || date === undefined
    ? NaN
    : typeof date === 'string'
    ? parseISO(date)
    : date
}

/**
 * Bucketise a value in a bucket of the given resolution.
 * The goal is to decrease cardinalities
 */
export const bucket = (value: number, resolution: number): number =>
  Math.floor(value / resolution) * resolution

/**
 * Get bucketed diff in days between two dates
 * Return null, if dates are empty or the diff is negative
 */
export function daysBucket(to: DateOrNone, from: DateOrNone): number | null {
  const days = differenceInCalendarDays(asDate(to), asDate(from))
  if (isNaN(days) || days < 0) {
    return null
  }

  if (days < 10) {
    return days
  } else if (days <= 20) {
    return bucket(days, 5)
  } else if (days <= 90) {
    return bucket(days, 10)
  }
  return bucket(days, 90)
}

/**
 * Returns an age bucket like this :
 * - bucket length of 5 until 18
 * - bucket from 18 to 25
 * - and bucket length of 10 from 25
 */
export function ageBucket(date: DateOrNone) {
  if (!date) {
    return null
  }
  const years = differenceInYears(new Date(), asDate(date))
  return years < 18
    ? bucket(years, 5)
    : years >= 18 && years < 25
    ? 18
    : bucket(years + 5, 10) - 5
}
